import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { SystemConfig } from "@app/models/rest/system-config";

@Injectable({
  providedIn: "root"
})
export class SystemConfigService extends HateoasResourceOperation<SystemConfig> {
  constructor() {
    super(SystemConfig);
  }
}
